import React, { FC, useContext, useEffect, useState } from 'react';
import { FaChevronDown, FaFlag, FaMoneyBillAlt, FaTimes } from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as styles from './privateSidebar.styles';
import { UserContext } from '../../contexts/UserContext';
import { Dropdown } from 'flowbite-react';
import client from '../../api/client';
import { useCurrency } from '../../contexts/CurrencyContext';
import homeIcon from '../../assets/home-2.png';
import businessIcon from '../../assets/buildings.png';
import accountIcon from '../../assets/user.png';
import balanceIcon from '../../assets/wallet.png';
import payoutsIcon from '../../assets/wallet-minus.png';
import refundIcon from '../../assets/recovery-convert.png';
import chargebackIcon from '../../assets/send-sqaure-2.png';
import settingsIcon from '../../assets/setting-2.png';
import shoppingcartIcon from '../../assets/shopping-cart.png';
import timerIcon from '../../assets/timer-start.png';
import billIcon from '../../assets/money.png'

interface PrivateSidebarProps {
  closeSidebar: () => void;
}

const PrivateSidebar: FC<PrivateSidebarProps> = ({ closeSidebar }) => {
  const [openDropdowns, setOpenDropdowns] = useState<string[]>([]);
  const [activeItem, setActiveItem] = useState<string | null>(null);
  const [activeSubItem, setActiveSubItem] = useState<string | null>(null);
  const [balances, setBalances] = useState<any[]>([]);
  const navigate = useNavigate();
  const { userDetails } = useContext(UserContext) ?? {};
  const { availableCurrencies, currency, setCurrency } = useCurrency() ?? {};
  const location = useLocation()

  useEffect(() => {
    const savedActiveItem = localStorage.getItem("activeItem");
    const savedActiveSubItem = localStorage.getItem("activeSubItem")
    if (savedActiveItem) {
      setActiveItem(savedActiveItem);
      if (!openDropdowns.includes(savedActiveItem)) {
        setOpenDropdowns([...openDropdowns, savedActiveItem]);
      }
    }
    if (savedActiveSubItem) {
      setActiveSubItem(savedActiveSubItem)
    }

    const fetchData = async () => {
      await fetchBalances();
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (activeItem) {
      localStorage.setItem("activeItem", activeItem);
    }

  }, [activeItem]);


  const handleItemClick = (label: string, hasItems:boolean) => {
    localStorage.removeItem('activeItem')
    localStorage.removeItem('activeSubItem')
    if (activeItem === label) {
      setOpenDropdowns(openDropdowns.filter(item => item !== label));
    }

    if(hasItems){
      if (openDropdowns.includes(label)) {
        setOpenDropdowns(openDropdowns.filter(item => item !== label));
      } else {
        setOpenDropdowns([...openDropdowns, label]);
      }

    }
    else{
      setOpenDropdowns([])
      localStorage.removeItem("activeSubItem")
      window.scrollTo(0, 0);
    }

    setActiveItem(label);

  };
  


  const handleSubItemClick = (e: React.MouseEvent, subLabel: string, parentLabel: string, route:string) => {
    setActiveSubItem(subLabel);
    localStorage.setItem("activeSubItem", subLabel);

    // navigate(`/${parentLabel.toLowerCase()}/${subLabel.toLowerCase().replace(/\s+/g, '-')}`, { replace: false });
    navigate(`${route}`, { replace: false });

  };

  const isActiveItem = (path: string) => location.pathname === path ? 'font-semibold text-black  border-2 bg-green-50 shadow-none' : '';


  const fetchBalances = async () => {
    try {
      const response = await client.get('/subsidiary/dashboard/get/wallet/balance');
      setBalances(response.data.wallets);
    } catch (err: any) {
      if (err?.response?.data?.message === 'Please login again') {
        sessionStorage.clear();
        window.location.href = '/';
      } else {
        console.error('Error getting data', err);
      } 
    }
  };

  const items = [
    {
      icon: businessIcon,
      label: 'Business',
      items: [
        { name: 'Transactions', route: '/business/transactions' },
        { name: 'Customers', route: '/business/customers' },
        { name: 'Payment Links', route: '/business/payment-links' },
      ],
    },
    {
      icon: accountIcon,
      label: 'Account',
      items: [
        { name: 'Virtual Accounts', route: '/account/virtual-accounts' },
        { name: 'Settlements', route: '/account/settlements' },
      ],
    },
    {
      icon: balanceIcon,
      label: 'Balance',
      items: [
        { name: 'Balance', route: '/balance' },
        { name: 'Balance History', route: '/balance/balance-history' },
        { name: 'Rolling Reserve', route: '/balance/rolling-reserve' },
      ],
    },
    {
      icon: payoutsIcon,
      label: 'Transfers',
      items: [
        { name: 'Transfers', route: '/transfers' },
        { name: 'Pending Approval', route: '/transfers/pending-approval' },
        { name: 'Beneficiaries', route: '/transfers/beneficiaries' },
        { name: 'Funding History', route: '/transfers/funding-history' },
      ],
    },
    {
      icon: billIcon,
      label: 'Bill Payments',
      items: [
        { name: 'Pay Bills', route: '/bills-payment/initiate' },
        { name: 'Bills Payment History', route: '/bills-payment/history' },
      ],
    },
    {
      icon: shoppingcartIcon,
      label: 'Online Store',
      items: [],
    },
    {
      icon: refundIcon,
      label: 'Refunds',
      items: []
    },
  ];
  

  return (
    <div>
      <div className={styles.main}>
        <div className={styles.userInfo}>
          <div className="flex gap-4">
            {userDetails.activeSubsidiary.subsidiaryLogo ? (
              <div className='h-10 w-10'>
                <img src={userDetails.activeSubsidiary.subsidiaryLogo} alt="Logo" />
              </div>
            ) : (
              <div className={styles.businessLogo}>
                {userDetails.activeSubsidiary.businessName.charAt(0)}
              </div>
            )}
            <div>
              <p className={styles.businessName}>{userDetails.activeSubsidiary.businessName}</p>
              <div className={styles.businessDetails}>
                <p>Merchant Id - {userDetails.activeSubsidiary.id}</p>
                <FaChevronDown className="mt-0" />
              </div>
            </div>
          </div>
          <FaTimes className={styles.closeIcon} onClick={closeSidebar} />
        </div>
        <div className={styles.getStartedSection}>
          <Link to="/overview">
            <div className={styles.getStartedContainer}>
              <img src={timerIcon} alt="Timer" />
              <p className="font-semibold">Getting Started</p>
            </div>
          </Link>
          <div className="px-10">
            <div className='border rounded-full flex items-center justify-center p-4'>
              <Dropdown
                label={
                  <div className="flex items-center">
                    <FaFlag className='mr-2' />
                    {currency}
                  </div>
                }
                dismissOnClick={true}
                inline
              >
                {availableCurrencies && (
                  availableCurrencies.map(currency => (
                    <Dropdown.Item key={currency.shortName} onClick={() => setCurrency(currency.shortName)}>
                      <div className="flex items-center">
                        <FaFlag className='mr-2' />
                        {currency.shortName}
                      </div>
                    </Dropdown.Item>
                  ))
                )}
              </Dropdown>
            </div>
          </div>
        </div>
        <div className={styles.generalContainer}>
          <p className={styles.categoryHeader}>GENERAL</p>
          <div className={`flex gap-2 text-sm p-2 rounded-lg hover:text-green-400 cursor-pointer ${isActiveItem('/overview')} 'font-light text-gray-500'}`} onClick={() => { handleItemClick('Dashboard', false); navigate("/overview") }}>
            <img src={homeIcon} alt="home" />
            <span>Dashboard</span>
          </div>
        </div>
        <div className="border-b border-gray-200 py-4 px-2">
          {items.map((item) => (
            <div key={item.label} className="">
              <div
                className={`${styles.linkItemContainer} flex gap-2 text-sm p-2 rounded-lg hover:text-green-400 ${isActiveItem(`/${item.label.toLowerCase().replace(/\s+/g, '-')}`)} 'font-light text-gray-500'}`}
                onClick={() => {
                  // if (activeItem !== item.label) {
                    handleItemClick(item.label, item.items ? true : false);
                    if (item.items.length == 0) {
                      setActiveItem(item.label)
                      navigate(`/${item.label.toLowerCase().replace(/\s+/g, '-')}`);
                      window.scrollTo(0, 0)
                    }

                  // }
                }}
              >
                <div className={styles.linkItem}>
                  <img src={item.icon} alt={item.label} className={styles.linkIcon} />
                  <span className="text-sm">{item.label}</span>
                </div>
                {item.items.length >0 && <FaChevronDown className={`transition-transform ${openDropdowns.includes(item.label) ? 'transform rotate-180' : ''}`} />}
              </div>
              {openDropdowns.includes(item.label) && item.items && (
                <div className={styles.subItemContainer}>
                  {item.items.map(subMenu => (
                    <div key={subMenu.name} className={`${styles.subItem} ${activeSubItem === subMenu.name ? 'border-2 bg-green-50 shadow-none' : ''}`} onClick={(e) => handleSubItemClick(e, subMenu.name, item.label, subMenu.route)}>
                      {subMenu.name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className={styles.supportContainer}>
          <p className={styles.categoryHeader}>SUPPORT</p>
          {[
            { icon: chargebackIcon, label: 'Chargebacks', items: [{name:"All Chargebacks", route:"/chargebacks/all-chargebacks"}, {name:"Pending", route:"/chargebacks/pending"}, {name:"Awaiting Response", route:"/chargebacks/awaiting-response"}, {name:"Won", route:"/chargebacks/won"}, {name:"Lost",route:"/chargebacks/lost"}, {name:"Assessment",route:"/chargebacks/assessment"}] },
            { icon: settingsIcon, label: 'Settings', items:[] },
          ].map((item) => (
            <div key={item.label} className="">
              <div
                className={`${styles.linkItemContainer} flex gap-2 text-sm p-2 rounded-lg hover:text-green-400 ${isActiveItem(`/${item.label.toLowerCase().replace(/\s+/g, '-')}`)} 'font-light text-gray-500'}`}
                onClick={() => {
                    handleItemClick(item.label, item.items ? true : false);
                    if (item.items.length == 0) {
                      navigate(`/${item.label.toLowerCase()}`);
                    }
                }}
              >
                <div className={styles.linkItem}>
                  <img src={item.icon} alt={item.label} className={styles.linkIcon} />
                  <span className="text-sm">{item.label}</span>
                </div>
                {item.items.length >0 && <FaChevronDown className={`transition-transform ${openDropdowns.includes(item.label) ? 'transform rotate-180' : ''}`} />}
              </div>
              {openDropdowns.includes(item.label) && item.items && (
                <div className={styles.subItemContainer}>
                  {item.items.map(subMenu => (
                    <div key={subMenu.name} className={`${styles.subItem} ${activeSubItem === subMenu.name ? 'border-2 bg-green-50 shadow-none' : ''}`} onClick={(e) => handleSubItemClick(e, subMenu.name, item.label, subMenu.route)}>
                      {subMenu.name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivateSidebar;